import { render, staticRenderFns } from "./DashFinanceiro.vue?vue&type=template&id=d68695f6&"
import script from "./DashFinanceiro.vue?vue&type=script&lang=ts&"
export * from "./DashFinanceiro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports